/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ReferencedComponent from './ReferencedComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class NodeCollection extends ReferencedComponent
{
    @property([cc.Node])
    protected nodes: cc.Node[] = [];
    public get Nodes(): cc.Node[] { return this.nodes; }

    public GetNodeComponents<T extends cc.Component>(comp: { new(): T }): T[]
    {
        const components: T[] = [];
        this.nodes.forEach(node =>
            {
                const foundComp: T[] = node.getComponents(comp);
                if (!foundComp) { return; }
                components.push(...foundComp);
            });
        return components;
    }
}
